module.exports = __webpack_public_path__ + "static/index/img/baikal-504.3a3ca6dd.jpg";